<template>
  <div class="menu-wrapper">
    <template v-for="item in leilist">
      <router-link :to="item.path" :key="item.meta.name" v-if="!item.children">
        <el-menu-item :index="item.path" :class="{'submenu-title-noDropdown':!isNest}" @click="menuClik(item)">
          <i :class="item.meta.icon"></i>
          <span slot="title">{{ item.meta.title }}</span>
        </el-menu-item>
      </router-link>
      <el-submenu :index="item.meta.title||item.path" :key="item.meta.title" v-else>
        <template slot="title">
          <i :class="item.meta.icon"></i>
          <span slot="title">{{ item.meta.title }}</span>
        </template>
        <template v-for="child in item.children">
          <router-link :to="child.path" :key="child.meta.title">
            <!-- -->
            <el-menu-item :index="child.path" @click="menuClik(child)">
              <img v-if="child.meta.title=='公众号管理'" src="../../../../assets/image/whitewe.png" alt=""
                   style="margin-right: 10px;margin-left: 5px;">
              <i :class="child.meta.icon"></i>
              <span slot="title">{{ child.meta.title }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      leilist: [],
    }
  },

  created() {
    this.initMenu()
  },
  methods: {
    menuClik(val) {
      if (val) {
        localStorage.setItem("Menuids", val.id);
      }
    },
    applyMenu(menu) {
      if (!menu) return
      this.leilist = menu
      try {
        const pageIndexMenuids = menu[0].children[0].id
        if (pageIndexMenuids > 0) {
          localStorage.setItem("Menuids", pageIndexMenuids)
        }
      } catch (e) {
        localStorage.setItem("Menuids", 19)
      }
    },
    initMenu() {
      // 1) 优先用 sessionStorage 中的权限缓存（路由守卫已写入），先渲染菜单
      try {
        const raw = sessionStorage.getItem('cachedPermission')
        if (raw) {
          const cached = JSON.parse(raw)
          if (cached && cached.menu && cached.menu.length) {
            this.applyMenu(cached.menu)
            return
          }
        }
      } catch (e) { /* 忽略缓存解析错误 */ }
      // 2) 缓存未命中再调接口（仅首次进系统会走这里）
      this.fetchMenu()
    },
    fetchMenu() {
      this.$api.get('/sys/permission/getUserPermissionByToken').then((res) => {
        if (res.data.success === true) {
          try {
            sessionStorage.setItem('cachedPermission', JSON.stringify(res.data.result))
          } catch (e) { /* 忽略存储异常 */ }
          this.applyMenu(res.data.result.menu)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue